<form [formGroup]="aangifteDbFg">
    <div>
        <div class="row">
            <div class="col col-1">
                <p>Bedrag uitgekeerde agioreserves in geld</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="bedragAgioInGeld"
                                                  id="bedragAgioInGeld"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
    <div>
        <div class="row">
            <div class="col col-1">
                <p>Bedrag uitgekeerde agioreserves in bonusaandelen</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="bedragAgioInBonusaandelen"
                                                  id="bedragAgioInBonusaandelen"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>

        </div>
    </div>
    <div *ngIf="aangifteDbFg.get('bedragAgioInGeld')?.value !== null || aangifteDbFg.get('bedragAgioInBonusaandelen')?.value !== null">
        <div class="row">
            <div class="col col-1">
                <p>Stand agioreserve voor uitkering</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="standAgioVoorUitkering"
                                                  id="standAgioVoorUitkering"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>

        </div>
    </div>
    <div>
        <div class="row">
            <div class="col col-1">
                <p>Bedrag eerder ten onrechte vrijgestelde inkoop aandelen</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="bedragTenOnrechteVrijgesteldeInkoopAandelen"
                                                  id="bedragTenOnrechteVrijgesteldeInkoopAandelen"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>

        </div>
    </div>
</form>
<form [formGroup]="dividendFg">
    <div>
        <div class="row">
            <div class="col col-1">
                <p>Bedrag onbelast verbod op extraterritoriale heffing</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="bedragOnbelastVerbodExtraterritorialeHeffing"
                                                  id="bedragOnbelastVerbodExtraterritorialeHeffing"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>

        </div>
    </div>
</form>
